import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.scss";

import { Flex, Image, useMediaQuery } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";

import { CardComponentProps } from "src/pages/home/pages/events/eventCard";
import { Event } from "src/types/commonTypes";
import LEFT_ARROW from "../resources/icons/button-arrow-left-enabled.svg";
import LEFT_ARROW_DISABLED from "../resources/icons/button-arrow-left-disabled.svg";
import RIGHT_ARROW from "../resources/icons/circle-arrow-right-01.svg";
import RIGHT_ARROW_DISBLED from "../resources/icons/button-arrow-right-disabled.svg";
import Slider from 'react-slick';

type CarouselProps = {
    CardComponent: React.FC<CardComponentProps>;
    eventList: Event[];
    rows: number;
    slidesToShow : number;
}

export const Carousel: React.FC<CarouselProps> = ({ CardComponent, eventList, rows, slidesToShow }) => {
    const sliderRef = useRef<(Slider | null)>(null);
    
    const [currentSlide, setCurrentSlide] = useState(0);
    const [disableNext, setDisableNext] = useState(false);
    const [disablePrev, setDisablePrev] = useState(false);

    
    const [isSm] = useMediaQuery('(max-width: 480px)');
    const [isMd] = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const [isLg] = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    let slides = slidesToShow;
    if (isSm || isMd) {
        slides = 1;
    } else if (isLg) {
        slides = 2;
    }
    useEffect(() => {
        const totalSlides = rows > 1 ? currentSlide*2 + slides*rows : currentSlide + slides;
        if (currentSlide === 0) {
            setDisablePrev(true);
        } else {
            setDisablePrev(false);
        }
    
        if (slides && totalSlides >= eventList.length) {
            setDisableNext(true);
        } else {
            setDisableNext(false);
        }
    }, [currentSlide, slides, eventList, rows, setDisablePrev, setDisableNext]);

    
    const scrollNext = () => {
        if(disableNext) return;
        sliderRef?.current?.slickNext();
    };

    const scrollPrevious = () => {
        if(disablePrev) return;
        sliderRef?.current?.slickPrev();
    };

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: slides,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 1,
                },
            },
        ],
        arrows: false,
        rows: rows,

        afterChange: (current: number) => {
            setCurrentSlide(current);
            sliderRef?.current?.slickPlay();
        },
    };
    
    return (
        <Flex direction="column">
            <div className="custom-carousel">
                <Slider ref={sliderRef} {...settings}>
                    {eventList.map((event, index) => (
                        <div key={`${index}-index`}>
                            <CardComponent
                                event={event}
                            />
                        </div>
                        ))}
                </Slider>
            </div>
            <Flex justifyContent="center" gap={4} marginTop="60px">
                <Image
                    onClick={scrollPrevious}
                    src={disablePrev ? LEFT_ARROW_DISABLED : LEFT_ARROW}
                    _hover={{
                        opacity: 0.8,
                        transform: 'scale(1.05)',
                        transition:"transform 0.3s ease, opacity 0.3s ease"
                    }}
                />
                <Image
                    onClick={scrollNext}
                    src={disableNext ? RIGHT_ARROW_DISBLED :RIGHT_ARROW}
                    _hover={{
                        opacity: 0.8,
                        transform: 'scale(1.05)',
                        transition:"transform 0.3s ease, opacity 0.3s ease"
                    }}
                />
            </Flex>
        </Flex>
    );
} 